import VideoCallSocketService from "../video_call_socket_service";
import io from "socket.io-client";
import { API_BASE_URL } from "../../../../core/constants/app_constants";
import { VideoCallRequestType } from "../../../domain/enum/video_call_request_type";
import { VideoCallDataType } from "../../../domain/enum/video_call_data_type";
import { VideoCallStatus } from "../../../domain/enum/video_call_status";

class VideoCallSocketServiceImpl extends VideoCallSocketService {
    static #instance = null; // Private static instance
    constructor() {
        if (VideoCallSocketServiceImpl.#instance) {
            return VideoCallSocketServiceImpl.#instance; // Return existing instance
        }
        super();
        VideoCallSocketServiceImpl.#instance = this; // Store instance
        this.callSocket = null;
        this.userId = null;
        this.chatChannelId = null;
        this.onConnected = null;
        this.onDisconnect = null;
        this.onComplete = null;
        this.updateStatus = null;
        this.onError = null;
    }

    connect({ userId, token, chatChannelId, onConnected, onDisconnected, onComplete, onError, onUpdate }) {
        if (this.callSocket) return console.log('Video call socket already connected.');

        console.log('User connecting to VideoCallSocketService');

        this.userId = userId;
        this.chatChannelId = chatChannelId;
        this.onConnected = onConnected;
        this.onDisconnected = onDisconnected;
        this.onComplete = onComplete;
        this.onError = onError;
        this.onUpdate = onUpdate;

        this.callSocket = io(`${API_BASE_URL}/v2/video-call`, {
            path: '/socket.io',
            query: {},
            auth: {
                token,
            }
        });

        // On connect
        this.callSocket.on('connect', () => {
            console.log(`Connected to 'v2/video-call namespace with id:' ${this.callSocket.id}.`);

            this.callSocket.emit('request', {
                type: VideoCallRequestType.startVideoCall,
                data: {
                    userId,
                    chatChannelId,
                }
            });
        });

        // Result events
        this.callSocket.on('result_notice', (payload) => {
            const { type, message, data } = payload;

            switch (type) {
                case VideoCallRequestType.startVideoCall:
                    this.onUpdate(VideoCallStatus.ongoing, data);
                    break;
                case VideoCallRequestType.endVideoCall:
                    this.onUpdate(VideoCallStatus.ended, data);
                    break;
                default:
                    console.log(`Unknown result type '${type}'.`);
            }
        });

        // Error Events
        this.callSocket.on('error_notice', (payload) => {
            const { type, message, error } = payload;
            console.warn(`VideoCallSocketService: [${type ? type : '*️⃣'}] Error notice received - `, error);
            this.onError({ type, message });
            this.performDisconnection();
        });

        // Disconnect 
        this.callSocket.on('disconnect', () => {
            console.log(`Disconnected from v2/video-call namespace`);
            this.callSocket.emit('request', { type: VideoCallRequestType.endVideoCall, data: { userId: this.userId, chatChannelId: this.chatChannelId } });
            this.disconnect();
        });
    }

    async performDisconnection() {
        if (this.callSocket) {
            this.callSocket.emit("request", {
                type: VideoCallRequestType.endVideoCall,
                data: {
                    chatChannelId: this.chatChannelId,
                    userId: this.userId
                }
            });
            this.callSocket.disconnect();
            this.callSocket = null;
            this.userId = null;
            this.chatChannelId = null;
            this.onConnected = null;
            this.onDisconnect = null;
            this.onComplete = null;
            this.updateStatus = null;
            this.onError = null;
        }
    }

    on(event, callback) {
        if (this.callSocket) {
            this.callSocket.on(event, callback);
        }
    }

    emit(event, payload = {}) {
        if (this.callSocket) {
            this.callSocket.emit(event, payload);
        }
    }

    disconnect() {
        this.performDisconnection();

        if (this.onDisconnected) {
            this.onDisconnected();
        }
    }
}

export default VideoCallSocketServiceImpl;